/**
 * Action Buttons
 * 
 * @Author: Focci
 * @Date: 2023-08-06 17:09:17
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-06 17:09:17
 */

import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { Button, CircularProgress } from '@comp/material'

export default function ActionButtons({
  onConfirm = () => {},
  onCancel = () => {},
  size = 'large',
  loading = false,
  disabled = false,
  cancelLabel = null,
  confirmLabel = null,
  ...buttonProps
}) {
  const tc = useTranslations('common')
  return (
    <div className="w-full grid grid-cols-3 gap-2">
      <Button
        size={size}
        color="lightButton"
        onClick={onCancel}
        {...buttonProps}
      >
        {cancelLabel || tc('reset')}
      </Button>
      <Button
        size={size}
        className="col-span-2 flex gap-1"
        onClick={onConfirm}
        disabled={loading || disabled}
        {...buttonProps}
      >
        {loading && <CircularProgress size="1.2em" />}
        {!loading && (confirmLabel || tc('confirm'))}
      </Button>
    </div>
  )
}

ActionButtons.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  size: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  cancelLabel: PropTypes.node,
  confirmLabel: PropTypes.node,
}
